module.exports = __webpack_public_path__ + "img/tg_02 (6).566af271.jpg";